Jelly.Actions.Show_Result = function(Parameters)
{	
	// Registers an action result element for a reference.
	// Parameters:  Namespace, Content, Input_Alias
	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug)
	{
		Jelly.Debug.Group("Display Result");
		Jelly.Debug.Log(Parameters);
	}
	
	// Lookup reference
	var Action_Element = document.getElementById(Parameters["Namespace"]);
	var Action_Reference = Jelly.References.Get_Reference_For_Element(Action_Element);
	// TODO - since it's a "calling reference" that's passed in, could be anything.   Not sure if it makes sense to just work off of "Result_Element" explicitly instead of the below, which requires "Action"s for updating results.
	if (!Jelly.Actions.Is_Action_Reference(Action_Reference))
		return;
	
	// Get the action or input result element
	var Result_Element = null;
	if (Parameters["Input_Alias"])
	{	
		// Get input...
		var Input_Alias = Parameters["Input_Alias"];

		// Verify input
		if (!Action_Reference.Inputs[Input_Alias])
		{
			Jelly.Debug.Display_Error("Tried to add input result for non-existing input: " + Input_Alias);
			return;
		}
		var Input = Action_Reference.Inputs[Input_Alias];
		
		// Get result element 
		if (Input["Result_Element"])
			Result_Element = Input["Result_Element"];			
	}
	else
	{
		if (Action_Reference["Result_Element"])
			Result_Element = Action_Reference["Result_Element"];
	}
	
	// If there's a result element, then display the result content inside of the result element.
	if (Result_Element)
	{
		var Content = Parameters["Content"];
		Result_Element.innerHTML = Content;

		// If this is a fallback, don't show if this thing already exists
		if (!Parameters.As_Fallback || !$(Result_Element).is(':visible')) {
			// Show the result if it has any actual text besides white space
			var Result_Item = $(Result_Element);
			var Content_Text = Result_Item.text();
			if (/\S/.test(Content_Text)) { 	
				Result_Item.wrapInner("<span/>");
				Result_Item.show().css("display", "flex");

				// For modal footer errors, allow a click to close to get it out of the way.
				if (!Parameters["Input_Alias"])
					Result_Item.on("click", function(){$(this).hide();});
			}
		}
		
		// Semantic has some insane problems with display: inline !important.   The only place to override it is with displayType.  It tries to "auto-guess" when to do inline, but it gets them wrong.
		// var SEMANTIX_SUX_Transition_Settings = {
		// 	animation: 'slide down',
		// 	reverse: false
		// };
		// if (Result_Item.data("SEMANTIC_SUX".toLowerCase()))
		// 	SEMANTIX_SUX_Transition_Settings["displayType"] = "block";		
			
		// console.log(Result_Item.data);
		
		// if (/\S/.test(Content_Text)) { 	
		// 	if ((Result_Item.css("display") == "none" || Result_Item.css("visibility") == "hidden") || Result_Item.transition('is animating'))
		// 		if (Result_Item.transition('is animating'))
		// 			Result_Item.transition('stop');
		// 		Result_Item.transition(SEMANTIX_SUX_Transition_Settings);
		// }
	}

	// If this has an input alias, make a fallback plan to show a generic error at the bottom if one isn't showing
	// This behavior is exemptable by using the flag No_Action_Error in the tag or js call
	if (!Parameters.No_Action_Error) {
		if (Parameters["Input_Alias"]) { 
			Jelly.Actions.Show_Result({
				Namespace: Parameters.Namespace, 
				Content: 'Please correct some information above, and try again', 
				As_Fallback: true
			});
		}
	}


	if (Debug)
	{
		Jelly.Debug.End_Group("");
	}
};